import { Trans } from '@lingui/react/macro';
import { AppBar, Link, Stack, Typography, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { branding } from '../branding';

export const Footer = () => {
  const theme = useTheme();
  const { logo, privacyPolicyUrl, name } = branding;

  const linkSx = {
    textDecoration: 'none',
    color: theme.palette.primary.dark,
  };
  const copyrightYear = new Date().getFullYear();

  return (
    <AppBar
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 2,
        backgroundColor: '#fff',
        width: '100%',
        borderTop: `solid 1px ${theme.palette.grey[200]}`,
        top: 'auto',
        bottom: 0,
        zIndex: 1250,
        m: 0,
        borderRadius: 0,
      }}
      component="footer"
      position="relative"
      elevation={0}
    >
      <Stack direction="row" alignItems="center">
        <img src={logo} alt="Logo" style={{ height: '22px', objectFit: 'contain' }} />
        <Typography variant="body2" sx={{ ml: 2, color: grey[800], fontWeight: 500 }}>
          <Trans>
            &copy;{copyrightYear} {name}. All rights reserved
          </Trans>
        </Typography>
      </Stack>

      <Stack direction="row" mr={7} spacing={3}>
        <Link href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" sx={{ ...linkSx }}>
          <Typography variant="body2" fontWeight="500" color={theme.palette.primary.dark}>
            <Trans>Privacy Policy</Trans>
          </Typography>
        </Link>
      </Stack>
    </AppBar>
  );
};
